<template>
    <component :is="component" :width="width" :preserveAspectRatio="preserveAspectRatio"></component>
</template>
<script>

    export default {
        props: {
            icon: String,
            width: {
                type: Number,
                default() {
                    return null;
                }
            },
            preserveAspectRatio: {
                type: String,
                default() {
                    return null;
                }
            }
        },
        computed: {
            component() {
                return () => import(`./${this.icon.toLowerCase()}.vue`);
            }
        }
    }
</script>